export default __webpack_public_path__ + "static/media/img13.5bc85e72.jpg";